export class NotFoundError extends Error {
  constructor() {
    super('Registro Não encontrado')
    this.name = 'NotFoundError'
  }
}
